import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {MOON_150} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const DialogTitle = styled(MuiDialogTitle)`
  && {
    padding: 16px 24px 8px 24px;
  }
`;
DialogTitle.displayName = 'S.DialogTitle';

export const TitlePanel = styled.div`
  display: flex;
  align-items: center;
`;
TitlePanel.displayName = 'S.TitlePanel';

export const Title = styled.div`
  flex: 1 1 auto;
  font-weight: 600;
  font-size: 24px;
`;
Title.displayName = 'S.Title';

export const CodeSnippet = styled.div`
  margin: 12px 0;
  padding: 16px;
  background-color: ${MOON_150};
  display: flex;
  align-items: center;
`;
CodeSnippet.displayName = 'S.CodeSnippet';

export const Code = styled.code`
  flex: 1 1 auto;
`;
Code.displayName = 'S.Code';

export const DialogActions = styled(MuiDialogActions)`
  && {
    justify-content: flex-start;
    padding: 0 24px 24px 24px;
  }
`;
DialogActions.displayName = 'S.DialogActions';
